document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-ak-menu-toggle]');
  if (!trigger) return;

  const navigation = document.querySelector('[data-ak-navigation]');
  if (!navigation) return;

  const isOpen = navigation.dataset.open === 'true';
  navigation.dataset.open = String(!isOpen);
  trigger.setAttribute('aria-expanded', String(!isOpen));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const navigation = document.querySelector('[data-ak-navigation]');
  const trigger = document.querySelector('[data-ak-menu-toggle]');
  if (navigation) navigation.dataset.open = 'false';
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
});
